<template>
  <div class="SingleInputor">
    <div class="p-lable">{{ propertyData[propertyDataKey].lable }}</div>
    <div class="p-singlecolorselector-wrap">
      <el-input v-model="value"
                @change="handleChange"
                placeholder="请输入"></el-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MapMaxSetting',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data () {
    return {
      value: '',
    };
  },

  mounted () {
    /* 获取初始值 */
    this.value = this.propertyData[this.propertyDataKey].value;
  },
  methods: {
    handleChange (val) {
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.SingleInputor {
  width: 100%;
  box-sizing: border-box;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }
  .p-singlecolorselector-wrap {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 0 15px;
    :deep().el-input input {
      height: 35px;
      color: #b6b8cc;
      background: #191b23;
      text-align: center;
      border: 1px solid rgba(139, 139, 139, 0.733);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
  .charts-style-config {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;

    .el-input {
      width: 35px;
      margin-right: 5px;
    }
    span {
      width: 60px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      padding-left: 2px;
      padding-right: 2px;
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
